if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/component/carousel.scss';
import './container-slider.scss';
import 'bootstrap/js/dist/carousel';
